/* eslint-disable import/prefer-default-export */
import { DataResponse } from '@b2chat/chat-center-sdk';
// eslint-disable-next-line import/no-cycle
import store from '@src/store/reduxstore'; //TODO: fix circular dependency from agentchatmanager

export const callApiQuery = async <ResultType, ArgType = void>(
  endpoint: { initiate: (arg: ArgType) => unknown },
  args?: ArgType
): Promise<ResultType | undefined> => {
  try {
    const result = await (store.dispatch(
      endpoint.initiate(args as ArgType)
    ) as Promise<DataResponse<ResultType>>);

    if (result.error) throw result.error;
    return result.data;
  } catch (error) {
    return undefined;
  }
};
